// extracted by mini-css-extract-plugin
export default {"avatar__thumbs":"avatar_avatar__thumbs__dkVzO","avatar__placeholder":"avatar_avatar__placeholder__ankWU","dot":"avatar_dot__FeNZi"};